import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SimpleSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../../common';
import { FailedMessagesReportFieldModel } from '../../models/profile/failed-messages-profile-report.model';
import { FailedMessagesProfileReportService } from './failed-messages-profile-report.service';
import {
  FailedMessagesProfileReportLoad,
  FailedMessagesProfileReportInitialState,
} from './failed-messages-profile-report.actions';

export interface FailedMessagesProfileReportStateModel {
  reportFields: FailedMessagesReportFieldModel[];
  loaded: boolean;
}

const initialState: FailedMessagesProfileReportStateModel = {
  reportFields: [],
  loaded: false,
};

@State<FailedMessagesProfileReportStateModel>({
  name: 'failedMessagesProfileReport',
  defaults: initialState,
})
@Injectable()
export class FailedMessagesProfileReportState {
  constructor(
    private failedMessagesProfileReportService: FailedMessagesProfileReportService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getReportFields(state: FailedMessagesProfileReportStateModel): FailedMessagesReportFieldModel[] {
    return state.reportFields;
  }

  @Selector()
  static getState(state: FailedMessagesProfileReportStateModel): FailedMessagesProfileReportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: FailedMessagesProfileReportStateModel): boolean {
    return state.loaded;
  }

  @Action(FailedMessagesProfileReportLoad)
  getReport(
    ctx: StateContext<FailedMessagesProfileReportStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.failedMessagesProfileReportService.getReport().pipe(
      map((reportFields: FailedMessagesReportFieldModel[]) => {
        ctx.patchState({
          reportFields,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(FailedMessagesProfileReportInitialState)
  setInitialState(ctx: StateContext<FailedMessagesProfileReportStateModel>): void {
    ctx.setState(initialState);
  }
}
